module.exports = __webpack_public_path__ + "static/media/process.a1ab6f81.jpg";